define('controllers/mysetting/namechange/name-change-mod-userinfoper.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('NameChangeModUserInfoPer', ['$q', '$scope', '$state', '$location', '$rootScope', '$controller', 'auiUpload',
        'auiDialog', 'regionService', 'modUserInfoService', 'formValidateService', 'UserInfoPreload', 'modBussService', 'langService','UserInfo','commonUtils',
        function ($q, $scope, $state, $location, $rootScope, $controller, auiUpload, auiDialog,
                  regionService, modUserInfoService, formValidateService, UserInfoPreload, modBussService, langService,UserInfo, commonUtils) {
            $controller('ModUserInfoPer', {$scope: $scope});//导入
            var Model = $scope.Model;
            var userInfo = Model.userInfo = {
                perCtfFg: '',
                perCtfBg: '',
                perCtf3: ''
            };
            Model.isHasBankInfoReview = false;
            Model.isTipShow = false;
            Model.firstmessTip = '';
            Model.secondmessTip = '';
            Model.submbIsGray = true;
            Model.doSubmit = function () {
            };
            Model.isRadioSelected = false;
            Model.isShowChaicon = true;
            Model.isAudting = false;
            Model.isRadioDisable = false;
            Model.isShowphoneValid = false;
            Model.channelOtherCheck = false;
            Model.isRepeatCtfCode = false;
            Model.verifiedEmailSuccess = false;
            Model.verifiedPhoneSuccess = false;
            Model.channelsList = systemParaConf.authentication.channels;
            Model.channelsChecked = [];
            Model.remark4userinfo = '';
            Model.isShowEmailValid = false;
            Model.notAltModDevName = false;
            Model.greenSubmit = greenSubmit;
            Model.graySubmit = graySubmit;
            $scope.photoUrl =  sysParamCfg.photoUrl;
            Model.userInfo.country = {
                'key': '',
                'value': ''
            };
            var oldUserInfo = {};
            var userInfoToString = '';

            Model.isEmailNeedCode = false;


            //定义各输入框对应的素数（控制提交按钮是否展示）
            var primes = modUserInfoService.returnPrimes();

            //SRM PRM错误信息展示
            Model.isShowPrmSrmTip = false;
            Model.PrmSrmMsgTip = "";
            // 显示语种集合
            Model.notifyMsgLangList = sysParamCfg.displaylangCountries;

            // 是否维护通知消息语种
            Model.showMsgLang = sysParamCfg.displayMsgLangFlag;

            init();

            function getExtAttr(name) {
                var defer = $q.defer();
                modUserInfoService.getExtAttr(name).then(function (flag) {
                    defer.resolve(flag);
                });
                return defer.promise;
            }

            function init() {
                modBussService.getMerchantInfo(function (bankInfos) {
                    //有境内银行帐号,且境内银行帐号和跨境银行帐号 在审核中的情况，则不展示更名按钮
                    if (bankInfos.bankInfoCN) {
                        if (bankInfos.bankInfoCN.verifyBankState === 1 || bankInfos.bankInfoCN.updateBankState === 1 ||
                            (bankInfos.bankInfoEN && (bankInfos.bankInfoEN.verifyBankState === 1 || bankInfos.bankInfoEN.updateBankState === 1))) {
                            Model.isHasBankInfoReview = true;
                        }
                    }

                    Model.userInfo.perRealName = UserInfoPreload.realName;
                    commonUtils.picExtend("imges1","imges3","imges2");
                    if (UserInfoPreload.alChgRealName != 1 || UserInfoPreload.isChangeRealName == 1 || UserInfoPreload.updateRealState == 1 || Model.isHasBankInfoReview) {
                        delete $rootScope.changeNameParams;
                        $state.go('mysetting.modUserInfoPer', {}, {reload: true});
                    } else {
                        Model.verifyBankState = UserInfoPreload.verifyBankState;
                        Model.countrys = [{'key': '中国', 'value': '中国'}];

                        regionService.setProvince(function (data) {
                            Model.provinces = data;

                            //获取cp信息展示
                            UserInfo.userAcctInfoList().then(function (userInfo) {
                                setUserInfo(userInfo);
                            });
                            Model.userInfo.country = Model.countrys[0];
                        });
                    }
                });
            }

            function validateData() {
                if (Model.isEmailNeedCode&& !Model.verifiedEmailSuccess) {
                    angular.element("[name='verifyEmailCode']").focus();
                    return false;
                }
                if (Model.isPhoneNeedCode && !Model.verifiedPhoneSuccess) {
                    angular.element("[name='verifyCode']").focus();
                    return false;
                }
                return true;
            }

            Model.uploadPerCtfBg = function (files, options) {
                upload2openUP(files, options, primes.idCardPicFgPrime, 'perCtfFg', 'idCardPicFgWH', 'perCtfFgValid');
            };

            //选择或或知渠道
            Model.selectChannel = function (value) {
                modUserInfoService.selectChannelType(value, Model, primes, undefined, undefined, oldUserInfo);
            }

            Model.uploadPerCtfBgImg = function (files, options) {
                upload2openUP(files, options, primes.idCardPicBgPrime, 'perCtfBg', 'idCardPicBgWH', 'perCtfBgValid');
            };

            Model.uploadPerCtf3Img = function (files, options) {
                upload2openUP(files, options, primes.idCarePic3Prime, 'perCtf3', 'idCardPic3WH', 'ctf3Valid');
            };

            Model.uploadAppealAttach = function (files, options) {
                upload2openUP(files, options, primes.appealAttach, 'appealAttach', 'appealAttach');
            };
            Model.uploadPerCtfNcImg = function (files, options) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        Model.userInfo.perCtfNc = fileUrl;
                        greenSubmit();
                        AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                            $scope.$apply(function () {
                                Model.idNameChangeWH = wh;
                            });
                        });
                    }
                });
            };




            function upload2openUP(files, options, prime, img, imgHW, isValid) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        if (isValid) {
                            Model.valid[isValid].isValidSuc = false;
                        }
                        Model.userInfo[img] = fileUrl;
                        drawImageForImage(fileUrl,imgHW);
                    }
                });
            }

            function drawImageForImage(fileUrl,imgHW) {
                AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                    $scope.$apply(function () {
                        Model[imgHW] = wh;
                    });
                });
            }

            Model.cancel = function () {
                delete $rootScope.changeNameParams;
                $rootScope.modFlag = false;
                delete $rootScope.isInNameChange;
                $state.go('mysetting.modUserInfoPer', {}, {reload: true});
            };



            Model.acceptEDMKeyup = function (acceptEDM) {
                Model.userInfo.acceptEDM = !acceptEDM;
            };


            Model.perCtfCodeKeyup = function (valid) {
                if (oldUserInfo.perCtfCode != Model.userInfo.perCtfCode && Model.userInfo.perCtfCodeFuzzy != Model.userInfo.perCtfCode) {
                    if (!formValidateService.testPerCtfCode(Model.userInfo.perCtfCode)) {
                        $scope.perUserForm.perCtfCode.$invalid = true;
                        $scope.perUserForm.perCtfCode.$error.pattern = true;
                        return;
                    }
                    $scope.perUserForm.perCtfCode.$invalid = false;
                    $scope.perUserForm.perCtfCode.$error.pattern = false;

                    modUserInfoService.checkUser({
                        userType: 1,
                        ctfCode: Model.userInfo.perCtfCode
                    }).then(function (res) {
                        if (res && res.isRepeat == 2) {
                            Model.isRepeatCtfCode = false;
                        } else if (res && res.isRepeat == 1) {
                            Model.isRepeatCtfCode = true;
                        } else {
                            auiDialog.failSystemError();
                        }
                    });

                }
                else {
                    Model.isRepeatCtfCode = false;
                    $scope.perUserForm.perCtfCode.$invalid = false;
                    $scope.perUserForm.perCtfCode.$error.pattern = false;
                }
            };

            // 提交按钮灰化
            function graySubmit() {
                if (oldUserInfo.perRealName == Model.userInfo.perRealName) {
                    Model.submbIsGray = true;
                    Model.doSubmit = function () {
                    };
                } else {
                    Model.submbIsGray = false;
                }
                if (!$rootScope.changeNameParams) {
                    $rootScope.modFlag = false;
                    delete $rootScope.isInNameChange;
                }
            }

            // 提交按钮亮化
            function greenSubmit() {
                if (oldUserInfo.perRealName != Model.userInfo.perRealName) {
                    Model.submbIsGray = false;
                    Model.doSubmit = doSummit;
                } else {
                    Model.submbIsGray = true;
                }
                $rootScope.modFlag = true;
                $rootScope.isInNameChange = true;
            }

            //修改提交
            function doSummit(isValid) {

                var defer = $q.defer();
                if (!Model.isRepeatCtfCode && !Model.submbIsGray) {
                    if (!isValid) {
                        defer.reject();
                        formValidateService.validateForm($scope.perUserForm);
                        validateData();
                    } else {
                        var params = getUpdateParam();
                        //渠道不为为空
                        if (Model.channelsChecked.length == 0) {
                            Model.channelOtherCheck = true;
                            defer.reject();
                            return;
                        } else {
                            Model.channelOtherCheck = false;
                        }
                        if (!validateData()) {
                            defer.reject();
                            return;
                        }

                        if (oldUserInfo.perRealName == Model.userInfo.perRealName) {
                            defer.reject();
                            auiDialog.warn('请修改真实姓名。');
                        } else {
                            if (UserInfoPreload.verifyBankState == 2) {
                                defer.resolve();
                                if ($rootScope.changeNameParams) {
                                    if (params.developerInfo) {
                                        $rootScope.changeNameParams.developerInfo = params.developerInfo;
                                    }
                                    if (params.indivDeveloper) {
                                        $rootScope.changeNameParams.indivDeveloper = params.indivDeveloper;
                                    }
                                } else {
                                    $rootScope.changeNameParams = params;
                                }
                                $state.go("nameChangePer.modBussnessInfo");
                            } else {
                                modUserInfoService.changeNameFun(angular.copy(params)).then(function (data) {
                                    if (data) {
                                        $rootScope.modFlag = false;
                                        delete $rootScope.isInNameChange;
                                        auiDialog.success("提交更名成功", function () {
                                            delete $rootScope.changeNameParams;
                                            $scope.$emit("stateChangedEvent", true);
                                            $state.go('mysetting.modUserInfoPer', {}, {reload: true});
                                        });
                                        defer.resolve();
                                    } else {
                                        defer.reject();
                                    }
                                }).catch(function () {
                                    defer.reject();
                                });
                            }
                        }
                    }

                } else {
                    defer.reject();
                }
                return defer.promise;
            }

            // 组织更新接口调用的请求参数
            function getUpdateParam() {
                /*
                 * 组装developerInfo数据
                 */
                var devObj = {};

                if (oldUserInfo.contactEmail != Model.userInfo.contactEmail) {
                    devObj.contactEmail = Model.userInfo.contactEmail;
                }
                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone) {
                    devObj.contactPhone = Model.userInfo.contactPhone;
                }
                devObj.acceptEDM = Model.userInfo.acceptEDM ? 1 : 2;

                if (oldUserInfo.qq != Model.userInfo.qq) {
                    devObj.contactQQ = Model.userInfo.qq;
                }
                if (oldUserInfo.realNameEn != $.trim(Model.userInfo.realNameEn)) {
                    // 隐藏数据提交
                    devObj.realNameEn = $.trim(Model.userInfo.realNameEn);
                }
                if (Model.isSupportDevName) {
                    if (oldUserInfo.devName4Inner != $.trim(Model.userInfo.devName4Inner)) {
                        // 隐藏数据提交
                        devObj.devName4Inner = $.trim(Model.userInfo.devName4Inner);
                    }
                }
                devObj.country = 'CN';


                // 需要验证的手机号码提交验证码
                if (Model.isPhoneNeedCode) {
                    devObj.smsAuthCode = Model.userInfo.verCode;
                }
                // 需要验证的手机号码提交验证码
                if (Model.isEmailNeedCode) {
                    devObj.emailAuthCode = Model.userInfo.verEmailCode;
                }


                if (Model.needAppealAttach && Model.userInfo.appealAttach) {
                    devObj.appealAttach = Model.userInfo.appealAttach;
                }


                /*
                 * 组装indivDeveloper数据
                 */
                var perObj = {};
                if (oldUserInfo.perRealName != $.trim(Model.userInfo.perRealName)) {
                    devObj.realName = $.trim(Model.userInfo.perRealName);
                    perObj.realName = Model.userInfo.perRealName;
                    // 隐藏数据提交
                    devObj.contactName = Model.userInfo.perRealName;
                }
                if (oldUserInfo.perCtfCode != Model.userInfo.perCtfCode && Model.userInfo.perCtfCode != Model.userInfo.perCtfCodeFuzzy) {
                    perObj.ctfCode = Model.userInfo.perCtfCode;
                }
                if (oldUserInfo.perCtfFg != Model.userInfo.perCtfFg) {
                    perObj.attachment1 = Model.userInfo.perCtfFg ? Model.userInfo.perCtfFg : '';
                }
                if (oldUserInfo.perCtfBg != Model.userInfo.perCtfBg) {
                    perObj.attachment2 = Model.userInfo.perCtfBg ? Model.userInfo.perCtfBg : '';
                }
                if (oldUserInfo.perCtf3 != Model.userInfo.perCtf3) {
                    perObj.attachment3 = Model.userInfo.perCtf3 ? Model.userInfo.perCtf3 : '';
                }
                if (oldUserInfo.indivAddress != $.trim(Model.userInfo.indivAddress)) {
                    perObj.indivAddress = $.trim(Model.userInfo.indivAddress);
                }
                if (oldUserInfo.perProvinceName != Model.userInfo.province.key) {
                    perObj.provinceName = Model.userInfo.province.key;
                    devObj.province = Model.userInfo.province.key;
                }
                if (oldUserInfo.perCityName != Model.userInfo.city.key) {
                    perObj.cityName = Model.userInfo.city.key;
                    devObj.city = Model.userInfo.city.key;
                }
                modUserInfoService.setLearnchannels(oldUserInfo,Model,devObj);

                if (oldUserInfo.remark4userinfo != Model.userInfo.remark4userinfo) {
                    devObj.remark4userinfo = $.trim(Model.userInfo.remark4userinfo);
                }

                if (oldUserInfo.msgLang != $.trim(Model.userInfo.msgLang)) {
                    // 通知消息语种
                    devObj.msgLang = Model.userInfo.msgLang;
                }


                perObj.attachment4 = Model.userInfo.perCtfNc;

                // 组装最终的请求参数对象
                var params = {};
                if (!AUI.BaseJSUtil.isEmptyArray(devObj)) {
                    params.developerInfo = devObj;
                }
                if (!AUI.BaseJSUtil.isEmptyArray(perObj)) {
                    params.indivDeveloper = perObj;
                }

                return params;
            }

            function setUserInfo(userInfo) {
                var userInfoCopy = angular.copy(userInfo);

                if (userInfoCopy.devName4Inner == undefined) {
                    userInfoCopy.devName4Inner = "";
                }
                modUserInfoService.saveOldUserInfo(oldUserInfo, userInfoCopy);
                userInfoToString = angular.toJson(angular.copy(userInfoCopy));
                if ($rootScope.changeNameParams && $rootScope.changeNameParams.developerInfo && $rootScope.changeNameParams.developerInfo.smsAuthCode) {
                    userInfoCopy.contactPhone = $rootScope.changeNameParams.developerInfo.contactPhone;
                }
                if ($rootScope.changeNameParams && $rootScope.changeNameParams.developerInfo && $rootScope.changeNameParams.developerInfo.emailAuthCode) {
                    userInfoCopy.contactEmail = $rootScope.changeNameParams.developerInfo.contactEmail;
                }
                Model.userInfo = angular.copy(userInfoCopy);


                Model.oldDevName4Inner = angular.copy(Model.userInfo.devName4Inner);
                Model.userInfo.perCtfCode = formValidateService.hiddenInfo(Model.userInfo.perCtfCode, 3, 4);
                Model.userInfo.perCtfCodeFuzzy = angular.copy(Model.userInfo.perCtfCode);
                // 省份目前需要通过接口获取到数据后进行映射
                Model.userInfo.province = {
                    'key': Model.userInfo.perProvinceName,
                    'value': regionService.getProvinceFromList(Model.userInfo.perProvinceName, Model.provinces)
                };

                // 城市目前需要通过接口获取到数据后进行映射
                if (!($rootScope.changeNameParams && $rootScope.changeNameParams.indivDeveloper && $rootScope.changeNameParams.indivDeveloper.cityName)) {
                    regionService.setCity(Model.userInfo.perProvinceName, function (data) {
                        Model.cities = data;
                        Model.userInfo.city = {
                            key: Model.userInfo.perCityName,
                            value: regionService.getCityFromList(Model.userInfo.perCityName, Model.cities)
                        };
                    });
                }

                //获取获知渠道
                if (Model.userInfo.learnchannels) {
                    Model.channelsChecked = Model.userInfo.learnchannels.split(';');
                    for (var ch = 0; ch < Model.channelsChecked.length; ch++) {
                        Model.channelsChecked[ch] = parseInt(Model.channelsChecked[ch]);
                    }
                }

                Model.isShowChaicon = true;
                Model.userInfo.perCtfNc = '';

                if ($rootScope.changeNameParams) {
                    Model.submbIsGray = false;
                    $rootScope.modFlag = true;
                    $rootScope.isInNameChange = true;
                    Model.doSubmit = doSummit;
                    var params = angular.copy($rootScope.changeNameParams);
                    var devObj = {};
                    var perObj = {};
                    if (!AUI.BaseJSUtil.isEmptyArray(params.developerInfo)) {
                        devObj = params.developerInfo;
                    }
                    if (!AUI.BaseJSUtil.isEmptyArray(params.indivDeveloper)) {
                        perObj = params.indivDeveloper;
                    }
                    if (devObj.realNameEn) Model.userInfo.realNameEn = devObj.realNameEn;
                    if (devObj.contactEmail) Model.userInfo.contactEmail = devObj.contactEmail;
                    if (devObj.contactQQ) Model.userInfo.qq = devObj.contactQQ;
                    if (devObj.acceptEDM) Model.userInfo.acceptEDM = devObj.acceptEDM == 1 ? true : false;
                    if (devObj.contactName) Model.userInfo.contactName = devObj.contactName;
                    if (perObj.realName) Model.userInfo.perRealName = perObj.realName;
                    if (devObj.smsAuthCode) {
                        Model.isPhoneNeedCode = true;
                        Model.userInfo.verCode = "";
                        Model.verifiedPhoneSuccess = true;
                    }
                    if (devObj.emailAuthCode) {
                        Model.isEmailNeedCode = true;
                        Model.userInfo.verEmailCode = "";
                        Model.verifiedEmailSuccess = true;
                    }
                    if (perObj.ctfCode) {
                        Model.userInfo.perCtfCode = formValidateService.hiddenInfo(perObj.ctfCode, 3, 4);
                    }
                    if (perObj.attachment1) {
                        Model.userInfo.perCtfFg = perObj.attachment1;
                    }
                    if (perObj.attachment2) {
                        Model.userInfo.perCtfBg = perObj.attachment2;
                    }
                    if (perObj.attachment3) {
                        Model.userInfo.perCtf3 = perObj.attachment3;
                    }
                    if (perObj.indivAddress) {
                        Model.userInfo.indivAddress = perObj.indivAddress;
                    }
                    if (perObj.provinceName) {
                        Model.userInfo.province.key = perObj.provinceName;
                        Model.userInfo.province.value = regionService.getProvinceFromList(perObj.provinceName, Model.provinces)
                    }
                    if (perObj.cityName) {
                        regionService.setCity(Model.userInfo.province.key, function (data) {
                            Model.cities = data;
                            Model.userInfo.city = {
                                'key': perObj.cityName,
                                'value': regionService.getCityFromList(perObj.cityName, Model.cities)
                            };
                        });
                    }
                    if (devObj.learnchannelsOther) {
                        Model.userInfo.learnchannelsOther = devObj.learnchannelsOther;
                    }

                    if (devObj.learnchannels) {
                        Model.channelsChecked = devObj.learnchannels.split(';');
                        for (var ch2 = 0; ch2 < Model.channelsChecked.length; ch2++) {
                            Model.channelsChecked[ch2] = parseInt(Model.channelsChecked[ch2]);
                        }
                    }
                    if (devObj.remark4userinfo) {
                        Model.userInfo.remark4userinfo = devObj.remark4userinfo;
                    }
                    if (devObj.appealAttach) {
                        Model.userInfo.appealAttach = devObj.appealAttach;
                    }
                    if (perObj.attachment4) {
                        Model.userInfo.perCtfNc = perObj.attachment4;
                    }


                }
                modUserInfoService.drawImage(Model, "perCtfBg", "idCardPicBgWH", $scope);
                modUserInfoService.drawImage(Model, "perCtfFg", "idCardPicFgWH", $scope);
                modUserInfoService.drawImage(Model, "perCtfNc", "idNameChangeWH", $scope);
                modUserInfoService.drawImage(Model, "perCtfBg", "idCardPicBgWH", $scope);


                // 选择的语种
                Model.selectedMsgLang = langService.getLangItemByLang(Model.userInfo.msgLang);
                //是否展示needAppealAttach 申诉附件
                getExtAttr('needAppealAttach').then(function (flag) {
                    if (flag == 1) {
                        Model.needAppealAttach = true;
                    }
                });

            }


            // 设置通知消息语种
            Model.changeMsgLang = function (selected) {
                Model.userInfo.msgLang = selected.key;
            };




        }]);
});

